<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { DropdownMenuContent, type DropdownMenuContentProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = withDefaults(
    defineProps<DropdownMenuContentProps & { class?: HTMLAttributes['class'] }>(),
    {
        sideOffset: 4,
    },
)
</script>

<template>
    <DropdownMenuContent
        v-bind="{ ...props, class: undefined }"
        :class="
            cn(
                'z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md',
                props.class,
            )
        "
    >
        <slot />
    </DropdownMenuContent>
</template>
